module.exports = __webpack_public_path__ + "static/media/44.63ef7e30.jpg";